"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseAdNavigationGroup = void 0;
var NavigationGroup_1 = require("./NavigationGroup");
var SeekBarHandler_1 = require("./SeekBarHandler");
var types_1 = require("./types");
/**
 * Navigation group that becomes active while a pause ad is showing.
 *
 * The creative is rendered below the UI, so the controls a viewer still needs stay reachable while
 * the large centered playback control is suppressed. Passing only the controls that remain usable is
 * what keeps the suppressed control out of reach: spatial navigation resolves focus targets from
 * group membership, not from the stylesheet.
 *
 * The dismiss button is always the first focus target, so the remote lands on the way out of the ad.
 */
var PauseAdNavigationGroup = /** @class */ (function (_super) {
    __extends(PauseAdNavigationGroup, _super);
    function PauseAdNavigationGroup(pauseAdStatusOverlay) {
        var components = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            components[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray([pauseAdStatusOverlay, pauseAdStatusOverlay.dismissButton], components, false)) || this;
        _this.seekBarHandler = new SeekBarHandler_1.SeekBarHandler(_this);
        return _this;
    }
    PauseAdNavigationGroup.prototype.defaultActionHandler = function (action) {
        if (action === types_1.Action.BACK) {
            // Hiding this group's container would remove the dismiss button and the click target while the
            // creative is still on screen. BACK therefore stays unhandled and keeps whatever meaning the
            // platform or the embedding application gives it.
            return false;
        }
        return _super.prototype.defaultActionHandler.call(this, action);
    };
    PauseAdNavigationGroup.prototype.disable = function () {
        _super.prototype.disable.call(this);
        // Keep the saved target while another visible group (such as Settings) interrupts this ad.
        // Once the ad overlay itself closes, the next ad must start at its Close action again.
        if (!this.container.isShown()) {
            this.clearActiveComponentBeforeDisable();
        }
    };
    PauseAdNavigationGroup.prototype.release = function () {
        this.seekBarHandler.release();
        _super.prototype.release.call(this);
    };
    return PauseAdNavigationGroup;
}(NavigationGroup_1.NavigationGroup));
exports.PauseAdNavigationGroup = PauseAdNavigationGroup;
